export default __webpack_public_path__ + "static/media/icon3dnotes.506245a6.png";